const capabilityCodes = [
  {
    id: 11,
    name: "Principles and Values",
    short: "K1",
    items: [
      { description: "Understand the principles and values of palliative care." }
    ]
  },
  {
    id: 12,
    name: "Unique responses",
    short: "K2",
    items: [
      { description: "Understand the unique responses of individuals, families and communities to life-limiting conditions, dying and death." }
    ]
  },
  {
    id: 21,
    name: "Communication",
    short: "D1",
    items: [
      { description: "Use person and family-centred communication in the context of palliative care." }
    ]
  },
  {
    id: 22,
    name: "Inclusive Care",
    short: "D2",
    items: [
      { description: "Provide inclusive and culturally safe care for people affected by life-limiting conditions." }
    ]
  },
  {
    id: 23,
    name: "Collaborative Care",
    short: "D3",
    items: [
      { description: "Provide collaborative and person-centred care to optimise quality of life for people with life-limiting conditions." }
    ]
  },
  {
    id: 31,
    name: "Legislation and Frameworks",
    short: "B1",
    items: [
      { description: "Respect ethical frameworks and legislation that support palliative care practice." }
    ]
  },
  {
    id: 32,
    name: "Ongoing Development",
    short: "B2",
    items: [
      { description: "Participate in activities to develop self and services in the provision of palliative care." }
    ]
  }
];



// [{
//     id: 2,
//     name: "Health professionals",
//     short: "HP",
//     items: [{
//         description: "Person-centred communication in the context of an individual’s responses to loss and grief, existential challenges, uncertainty and changing goals of care."
//     }, {
//         description: "Appreciation of and demonstrated respect for the diverse human and clinical responses of each individual throughout their illness trajectory."
//     }, {
//         description: "Understanding of principles for assessment and management of clinical and supportive care needs."
//     }, {
//         description: "The capacity for reflection and self-evaluation of one’s  professional and personal experiences and their cumulative impact on one’s self and others."
//     }]
// }, {
//     id: 3,
//     name: "Care workers",
//     short: "CW",
//     items: [{
//         description: "Person-centred communication to build trust, show empathy and demonstrate support for individuals and carers living with a life-limiting illness."
//     }, {
//         description: "Awareness of and demonstrated respect for the diverse human and clinical responses of each individual throughout their illness trajectory."
//     }, {
//         description: "Understanding of clinical and supportive strategies that are within the scope of practice for individuals with a life-limiting illness."
//     }, {
//         description: "The capacity to identify own emotional responses and ethical concerns and manage according to organisational policy and procedures."
//     }]
// }, {
//     id: 4,
//     name: "Educators",
//     short: "E",
//     items: [{
//         description: "Develop discipline-specific intended learning outcomes based on palliative care capabilities."
//     }, {
//         description: "Use reputable learning and teaching resources to support learners development of palliative care capabilities."
//     }, {
//         description: "Apply evidence-based learning and teaching strategies in palliative care education."
//     }]
// }, {
//     id: 1,
//     short: "S",
//     name: "Specialist palliative care professionals",
//     items: [{
//         description: "Advanced communication skills to establish, maintain and adapt effective therapeutic partnerships in the context of an individual’s responses to loss and grief, existential challenges, uncertainty and changing goals of care."
//     }, {
//         description: "The ability to negotiate mutually agreed goals of care within a therapeutic environment, and facilitate person-centred decision making to promote optimal outcomes."
//     }, {
//         description: "Demonstrated skills in providing individualised and evidence based interventions to address the diverse human and clinical responses and preferences of each individual throughout their illness trajectory."
//     }, {
//         description: "Advanced skills in holistic assessment of individuals with complex clinical and supportive care needs."
//     }, {
//         description: "Expertise in use of assessment data to develop and implement a personalised and evidence based management plan and modify this plan according to changing circumstances, needs and preferences."
//     }, {
//         description: "Understand the need for support for self and others and utilise appropriate support systems."
//     }, {
//         description: "Contribute to quality palliative care outcomes through research, professional, policy and service development activities."
//     }, {
//         description: "The ability to apply advanced understanding of contemporary legal, ethical and professional standards in palliative care service delivery and development."
//     }]
// }]

export {
    capabilityCodes
}